import { getSnowplowEventPayload, logAnalyticsEvent } from '../analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from '../analytics.const';

const { SITEWIDE_FOOTER } = ANALYTICS_CATEGORIES;

export const triggerSitewideFooterLinkClickEvent = (label: React.ReactNode): void => {
	const eventPayload = getSnowplowEventPayload({
		category: SITEWIDE_FOOTER,
		customData: { label },
		name: 'dlr_footer_link_click',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
